import {Typography} from '@mui/material'
import {DatePicker, Form, FormInstance, Input, Upload, UploadFile} from 'antd'
import locale from 'antd/es/date-picker/locale/it_IT'
import {FormattedMessage} from 'react-intl'

import CardCustom from 'src/components/elements/CardCustom/CardCustom'
import SecondaryButton from 'src/components/elements/Buttons/SecondaryButton/SecondaryButton'

import {mdiDelete} from '@mdi/js'
import Icon from '@mdi/react'
import {EnrollmentPatientFormStyled} from './EnrollmentPatientFormStyled'
import moment from 'moment'
import {useEffect, useRef, useState} from 'react'

type EnrollmentPatientFormProps = {
  form: FormInstance<any>;
};

type UploadListItemProps = {
  originNode: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  file: UploadFile<any>;
  fileList: UploadFile<any>[];
  actions: {
    download: () => void,
    preview: () => void,
    remove: () => void
  };
}

const EnrollmentPatientForm : React.FC<EnrollmentPatientFormProps> = ({form}) => {
  const {Dragger} = Upload
  const [fileListEl, setFileList] = useState<UploadFile<any>[]>([])
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const UploadListItem = ({originNode, file, fileList, actions}: UploadListItemProps) => {
    return (
      <>
        {
          fileList[0] === file &&
            <div className='upload-items-header'>
              <Typography style={{fontSize: '13px'}} variant='h5'>
                <span>{'FILE'}</span>
              </Typography>
            </div>
        }
        <div className='upload-item'>
          <Typography variant='h5'>
            <span>{file.name}</span>
          </Typography>
          <SecondaryButton onClick={() => actions.remove()} style={{padding: 'unset'}}>
            <Icon path={mdiDelete} size={1} />
          </SecondaryButton>
        </div>
      </>
    )
  }

  const EnrollmentForm = () => {
    return (
      <Form
        form={form}
        id='enrollment-form'
        layout='vertical'
      >
        <div className='patient-details'>
          <Form.Item
            label={'Cognome Paziente'}
            name={'lastName'}
            rules={[{required: true, message: 'Campo obbligatorio'}]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={'Nome Paziente'}
            name={'firstName'}
            rules={[{required: true, message: 'Campo obbligatorio'}]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={'Data di nascita'}
            name={'birthDate'}
            rules={[
              {required: true, message: 'Campo obbligatorio'},
              () => ({
                validator (_, value) {
                  if (value?.isAfter(moment())) {
                    return Promise.reject(new Error('La data di nascita non può essere nel futuro'))
                  }
                  return Promise.resolve()
                }
              })
            ]}
          >
            <DatePicker
              format='DD MMM YYYY'
              getPopupContainer={(trigger) => trigger}
              locale={locale}
              placeholder=''
            />
          </Form.Item>
        </div>
        <div className='enrollment-upload'>
          <Form.Item
            name={'file'}
            rules={[{required: true, message: 'Campo obbligatorio'}]}
            valuePropName={''}
          >
            <Dragger
              beforeUpload={() => false}
              fileList={fileListEl}
              itemRender={(originNode, file, fileList, actions) => (
                <UploadListItem actions={actions} file={file} fileList={fileList} originNode={originNode} />
              )}
              multiple
              onChange={({fileList: newFileList}) => {
                if (isMountedRef.current) {
                  setFileList(newFileList)
                  // eslint-disable-next-line react/prop-types
                  form.setFieldValue('file', newFileList)
                }
              }}
              showUploadList
            >
              <img alt='uploader' src={'/assets/images/upload.png'} />
              <Typography>
                <span>{'Clicca o trascina qui per caricare il file con il modulo di adesione'}</span>
              </Typography>
            </Dragger>
          </Form.Item>
        </div>
      </Form>
    )
  }

  return (
    <EnrollmentPatientFormStyled>
      <CardCustom title={
        <div className='custom-card-header'>
          <Typography fontWeight={700} variant='body2'><FormattedMessage id='patientData' /></Typography>
        </div>
      }
      >
        <EnrollmentForm />
      </CardCustom>
    </EnrollmentPatientFormStyled>
  )
}

export default EnrollmentPatientForm
